import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function Loading() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center  mt-20">
      <Typography className="pb-5" variant="h5">
        {t("Loading")}
      </Typography>
      <CircularProgress />
    </div>
  );
}

export default Loading;
